/*
 * @Author: qiuz
 * @Github: <https://github.com/qiuziz>
 * @Date: 2018-11-22 15:45:42
 * @Last Modified by: qiuz
 * @Last Modified time: 2018-11-22 17:34:47
 */

import './index.less';

import * as React from 'react';
import app_banner_btn from '../../assets/images/app-baner-btn.png';
import { detectOS } from '../../common/utils';

interface propTypes {
	data: Array<any>;
	location: any;
	isPC: Boolean
}

export default class LayoutHeader extends React.Component<propTypes, any> {
	static defaultProps = {
		data: [{
			title: '',
			link: '#'
		}],
		location: {},
		isPC: true
	}


	constructor(props: propTypes) {
		super(props);
		this.state = {
			currentTab: props.location.hash
		}
		console.log(detectOS());
	}

	// 点击跳转
	handleClick = (item: any) => (e: any) => {
		e.preventDefault();
		let anchorElement = document.getElementById(item.anchor);
		if (anchorElement) {
			anchorElement.scrollIntoView();
		}
	};

	// 手机下载APP
	downLoad() {
		window.location.href = `https://at.umeng.com/onelink/CKL99f`;
	}
	render() {
		const { data, isPC } = this.props;
		return (
			<div className={isPC ? "" : "app_header"}>
				{
					isPC ? <div className="layout_header">
						<ul className="layout_header-content">
							{
								data.map((item, index) => {
									return (
										<li key={index} className="layout_header-content_box" onClick={this.handleClick(item)}>
											<a>{item.title}</a>
										</li>
									)
								})
							}
						</ul>
					</div> : <img className="img-btn" src={app_banner_btn} alt='下载橙牛app' onClick={this.downLoad.bind(this)} />
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/component/header/index.tsx